/**
 * 字段数据类型
 * @author wangjiegj<wangjiegj@inspur.com>
 */

import {I18nUtil} from "../../../i18n/i18n-service";

/**
 * 字段数据类型
 */
enum GSPElementDataType {
    /**
     * 文本
     */
    String = 'String',

    /**
     * 备注
     */
    Text = 'Text',

    /**
     * 整数
     */
    Integer = 'Integer',

    /**
     * 浮点数
     */
    Decimal = 'Decimal',

    /**
     * 布尔型
     */
    Boolean = 'Boolean',

    /**
     * 日期型
     */
    Date = 'Date',

    /**
     * 日期时间型
     */
    DateTime = 'DateTime',

    /**
     * 二进制
     */
    Binary = 'Binary',
    /**
     * 空间数据类型
     */
    Geometry = 'Geometry'
}

export { GSPElementDataType };


export const GSPElementDataTypes:
    Array<{
        index: number, text: string, value: GSPElementDataType | string,
        canChangeLength: boolean, canChangePresicion: boolean, length: number, precision: number
    }> = [
        {
            index: 0, text: I18nUtil.instant("String"), value: GSPElementDataType.String, canChangeLength: true,
            canChangePresicion: false, length: 36, precision: 0
        },
        {
            index: 1, text: I18nUtil.instant("Text"), value: GSPElementDataType.Text, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        },
        {
            index: 2, text: I18nUtil.instant("Integer"), value: GSPElementDataType.Integer, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        },
        {
            index: 3, text: I18nUtil.instant("Decimal"), value: GSPElementDataType.Decimal, canChangeLength: true,
            canChangePresicion: true, length: 18, precision: 2
        },
        {
            index: 4, text: I18nUtil.instant("Boolean"), value: GSPElementDataType.Boolean, canChangeLength: false,
            canChangePresicion: false, length: 1, precision: 0
        },
        {
            index: 5, text: I18nUtil.instant("Date"), value: GSPElementDataType.Date, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        },
        {
            index: 6, text: I18nUtil.instant("DateTime"), value: GSPElementDataType.DateTime, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        },
        {
            index: 7, text: I18nUtil.instant("Binary"), value: GSPElementDataType.Binary, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        }, 
        {
            index: 8, text: I18nUtil.instant("Geometry"), value: GSPElementDataType.Geometry, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        }, {
            index: 9, text: I18nUtil.instant("UnifiedDataType"), value: 'UnifiedDataType', canChangeLength: false,
            canChangePresicion: false, length: 36, precision: 0
        }
    ];
/**
 * 字段数据类型（不包含业务字段）
 */
export const GSPElementDataTypesWithoutUdt: Array<{
    index: number, text: string, value: GSPElementDataType | string,
    canChangeLength: boolean, canChangePresicion: boolean, length: number, precision: number
}> = [
        {
            index: 0, text: I18nUtil.instant("String"), value: GSPElementDataType.String, canChangeLength: true,
            canChangePresicion: false, length: 36, precision: 0
        },
        {
            index: 1, text: I18nUtil.instant("Text"), value: GSPElementDataType.Text, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        },
        {
            index: 2, text: I18nUtil.instant("Integer"), value: GSPElementDataType.Integer, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        },
        {
            index: 3, text: I18nUtil.instant("Decimal"), value: GSPElementDataType.Decimal, canChangeLength: true,
            canChangePresicion: true, length: 18, precision: 2
        },
        {
            index: 4, text: I18nUtil.instant("Boolean"), value: GSPElementDataType.Boolean, canChangeLength: false,
            canChangePresicion: false, length: 1, precision: 0
        },
        {
            index: 5, text: I18nUtil.instant("Date"), value: GSPElementDataType.Date, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        },
        {
            index: 6, text: I18nUtil.instant("DateTime"), value: GSPElementDataType.DateTime, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        },
        {
            index: 7, text: I18nUtil.instant("Binary"), value: GSPElementDataType.Binary, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        },
        {
            index: 8, text: I18nUtil.instant("Geometry"), value: GSPElementDataType.Geometry, canChangeLength: false,
            canChangePresicion: false, length: 0, precision: 0
        }
    ];
export class GetDataTypesUtil {
    static GSPElementDataTypesWithouUdt(): Array<{
        index: number, text: string, value: GSPElementDataType | string,
        canChangeLength: boolean, canChangePresicion: boolean, length: number, precision: number
    }> {
        let types = new Array<any>();
        Object.assign(types, GSPElementDataTypes);
        types = types.slice(0, 8);
        return types;
    }
}



